/*
 * @Description: 
 * @Author: 黄维保
 * @Date: 2019-09-02 16:14:41
 * @LastEditTime: 2019-11-05 21:09:24
 * @LastEditors: 黄维保
 */
/**
 * response 过滤器
 *
 * @export
 * @param {*} res
 * @returns
 */
export default function filterResponse(res) {
    if (res.status !== 200) {
        return res
        // throw new Error(`error${res.status}`)
    }
    if (!res.data) {
        throw new Error('Failed to access backend service')
    }
    // res.data.errorCode && String(res.data.errorCode) !== '0' 接口返回没有errorCode 直接走error
    if (String(res.data.code) !== '0' || res.data.errorCode && String(res.data.errorCode) !== '0') {
        throw {
            response: res,
            status: res.status,
            request: res.request,
            responseText: res.data.msg,
            errorCode: res.data.code
        }
    }
    // 处理后端不返回data字段code为0的正常相应
    if (res.data.code === 0 && (res.data.data == undefined || res.data.data == null || res.data.data == 'null')) {
        return {
            data: {},
            response: res
        }
    }

    return {
        data: res.data.data,
        response: res
    }
}